let view = null;

export default {
	namespace: 'single-blog',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: BlogItemView } = await import(
			/* webpackChunkName: "blog-item-view" */ '../../templates/BlogItemView'
		);
		view = new BlogItemView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
